"use client";
import Link from "next/link";
import { useState, useEffect, useRef } from "react";

const pillars = [
  { key: "pr", title: "PR & Communications", href: "/work/pr" },
  { key: "content-and-seo", title: "Content & SEO", href: "/work/content-and-seo" },
  { key: "digital-marketing", title: "Digital Marketing", href: "/work/digital-marketing" }
];

export default function Nav(){
  const [open, setOpen] = useState(false);
  const [workDropdownOpen, setWorkDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setWorkDropdownOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <header className="sticky top-0 z-50 bg-white/70 backdrop-blur border-b">
      <div className="container py-3 flex items-center justify-between">
        <Link href="/" className="font-serif text-lg no-underline">Varun Shetty</Link>

        {/* Desktop */}
        <nav className="hidden md:flex gap-8 items-center text-sm">
          <div className="relative" ref={dropdownRef}>
            <Link 
              href="/work"
              className="no-underline hover:text-[var(--acc)] transition-colors flex items-center gap-1"
              onClick={(e) => {
                if (workDropdownOpen) {
                  e.preventDefault();
                  setWorkDropdownOpen(false);
                }
              }}
              onMouseEnter={() => setWorkDropdownOpen(true)}
              onMouseLeave={() => setWorkDropdownOpen(false)}
            >
              Work
              <svg 
                className={`w-3 h-3 transition-transform ${workDropdownOpen ? 'rotate-180' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </Link>
            {workDropdownOpen && (
              <div 
                className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg py-2"
                onMouseEnter={() => setWorkDropdownOpen(true)}
                onMouseLeave={() => setWorkDropdownOpen(false)}
              >
                <Link 
                  href="/work" 
                  className="block px-4 py-2 text-sm hover:bg-gray-50 no-underline"
                  onClick={() => setWorkDropdownOpen(false)}
                >
                  All Work
                </Link>
                {pillars.map((pillar) => (
                  <Link 
                    key={pillar.key} 
                    href={pillar.href} 
                    className="block px-4 py-2 text-sm hover:bg-gray-50 no-underline"
                    onClick={() => setWorkDropdownOpen(false)}
                  >
                    {pillar.title}
                  </Link>
                ))}
              </div>
            )}
          </div>
          <Link href="/about" className="no-underline">About</Link>
          <Link href="/contact" className="no-underline">Contact</Link>
        </nav>

        {/* Mobile toggle */}
        <button
          className="md:hidden px-3 py-2 border rounded-lg"
          onClick={()=>setOpen(v=>!v)}
          aria-label="Open menu"
        >
          Menu
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden border-t bg-white">
          <div className="container py-3 grid gap-3">
            <div>
              <div className="font-medium mb-2">Work</div>
              <div className="ml-4 grid gap-2">
                <Link href="/work" className="text-sm text-muted">All Work</Link>
                {pillars.map((pillar) => (
                  <Link 
                    key={pillar.key} 
                    href={pillar.href} 
                    className="text-sm text-muted"
                  >
                    {pillar.title}
                  </Link>
                ))}
              </div>
            </div>
            <Link href="/about">About</Link>
            <Link href="/contact">Contact</Link>
          </div>
        </div>
      )}
    </header>
  );
}